// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://assets.foursightonline.com/app/fonts/webfonts/webfonts.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.fn-profile .section-title {
  width: min(620px, 100%);
  margin-inline: auto;
}
.fn-profile .section-title__linkcontainer {
  flex-direction: column;
}
.fn-profile__blocks {
  --dotsGap: 10px;
}
.fn-profile__blocks .f-flex {
  align-items: center;
}
.fn-profile__blocks .f-flex:nth-child(1) .fn-profile__pic figure::before {
  display: none;
}
.fn-profile__blocks .f-flex:nth-child(even) {
  flex-direction: row-reverse;
}
.fn-profile__blocks .f-flex:nth-child(even) .fn-profile__pic figure::after {
  left: auto;
  right: calc(100% + var(--dotsGap));
}
.fn-profile__blocks .f-flex + div {
  margin-top: 100px;
}
@media only screen and (max-width: 767px) {
  .fn-profile__blocks .f-flex + div {
    margin-top: calc(60px / 2);
  }
}
@media only screen and (min-width: 768px) {
  .fn-profile__blocks .f-flex > div:first-child {
    width: 45%;
  }
}
@media only screen and (min-width: 768px) {
  .fn-profile__blocks .f-flex > div:last-child {
    width: 55%;
  }
}
.fn-profile__blocks .fn-col {
  position: relative;
}
.fn-profile__blocks .fn-col:nth-child(1) {
  width: 45%;
}
@media only screen and (max-width: 767px) {
  .fn-profile__blocks .fn-col:nth-child(1) {
    width: 100%;
  }
  .fn-profile__blocks .fn-col:nth-child(1):not(:last-child) {
    margin-bottom: 20px;
  }
}
.fn-profile__blocks .fn-col:nth-child(2) {
  width: 55%;
}
@media only screen and (max-width: 767px) {
  .fn-profile__blocks .fn-col:nth-child(2) {
    width: 100%;
  }
}
.fn-profile__pic {
  max-width: 284px;
  width: 100%;
  margin-inline: auto;
}
@media only screen and (max-width: 767px) {
  .fn-profile__pic {
    width: 200px;
  }
}
.fn-profile__pic figure {
  position: relative;
  padding-bottom: 100%;
}
.fn-profile__pic figure::before {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(100% + var(--dotsGap));
  width: 8px;
  height: 60px;
  background-image: url(https://assets.foursightonline.com/admin-uploads/docs/226/original.png);
}
@media only screen and (max-width: 991px) {
  .fn-profile__pic figure::before {
    display: none;
  }
}
.fn-profile__pic figure::after {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: calc(100% + var(--dotsGap));
  width: 62px;
  height: 8px;
  background-image: url(https://assets.foursightonline.com/admin-uploads/docs/219/original.png);
}
@media only screen and (max-width: 991px) {
  .fn-profile__pic figure::after {
    display: none;
  }
}
.fn-profile__pic figure img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 100%;
}
.fn-profile__pic h5 {
  font-size: calc(16px - 2px);
  margin-top: 20px;
  text-align: center;
  max-width: 170px;
  margin-inline: auto;
}
.fn-profile__content {
  max-width: 88%;
  margin-inline: auto;
}
.fn-profile__content p {
  line-height: 1.8;
}

.fn-framework__top {
  background-color: #6d6e71;
  padding: 30px;
}
@media only screen and (max-width: 991px) {
  .fn-framework__top {
    padding: 30px;
  }
}
.fn-framework__top h2 {
  color: #fff;
}
@media only screen and (max-width: 767px) {
  .fn-framework__top h2 {
    margin-bottom: var(--hGap);
  }
}
.fn-framework__top h3 {
  color: #fff;
  font-weight: normal;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.4;
}
.fn-framework__top p {
  color: #fff;
}
.fn-framework__bottom {
  max-width: 800px;
  margin-inline: auto;
  margin-top: 30px;
}
@media only screen and (max-width: 767px) {
  .fn-framework__bottom {
    margin-top: 30px;
  }
}
.fn-framework__bottom p {
  color: #6a6a6a;
}
.fn-framework__bottom img {
  width: 334px;
  margin-inline: auto;
  display: block;
}
@media only screen and (max-width: 767px) {
  .fn-framework__bottom .fn-row {
    flex-direction: column-reverse;
  }
}

.fn-preferences__sign {
  margin-bottom: 30px;
}
.fn-preferences__sign img {
  width: 130px;
}
.fn-preferences__icon {
  position: absolute;
  top: calc(60px - 20px);
  right: calc(60px - 20px);
  max-width: 220px;
  max-height: 180px;
  z-index: -1;
}
@media only screen and (max-width: 767px) {
  .fn-preferences__icon {
    max-width: 150px;
    top: 20px;
    right: 20px;
  }
}
.fn-preferences__blocks > .f-flex {
  margin-inline: 0;
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks > .f-flex + div {
    margin-top: 30px;
  }
}
.fn-preferences__blocks > .f-flex:nth-child(even) {
  flex-direction: row-reverse;
}
.fn-preferences__blocks > .f-flex > [class*=f-col-] {
  position: relative;
  padding: calc(60px - 20px);
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks > .f-flex > [class*=f-col-] {
    padding: 20px;
  }
}
.fn-preferences__blocks > .f-flex > [class*=f-col-]:nth-child(1) {
  background-color: var(--clrProfile);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
  z-index: 0;
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks > .f-flex > [class*=f-col-]:nth-child(1) {
    border-top-right-radius: 50px;
  }
}
.fn-preferences__blocks > .f-flex > [class*=f-col-]:nth-child(1) > *:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks > .f-flex > [class*=f-col-]:nth-child(1) > *:not(:last-child) {
    margin-bottom: var(--hGap);
  }
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks > .f-flex > [class*=f-col-]:nth-child(2) {
    background-color: #f2f2f2;
  }
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks > .f-flex > [class*=f-col-] [class*=f-col-] {
    width: 100%;
  }
  .fn-preferences__blocks > .f-flex > [class*=f-col-] [class*=f-col-]:not(:last-child) {
    margin-bottom: 30px;
  }
}
.fn-preferences__blocks h2 {
  color: #fff;
}
.fn-preferences__blocks h3 {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 24px;
  color: #fff;
  line-height: 1.3;
  font-weight: normal;
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks h3 {
    font-size: 20px;
  }
}
.fn-preferences__blocks ul + .f-flex {
  margin-block-start: 30px;
}
@media only screen and (max-width: 991px) {
  .fn-preferences__blocks ul + .f-flex > [class*=f-col-] {
    width: 100%;
  }
  .fn-preferences__blocks ul + .f-flex > [class*=f-col-]:not(:last-child) {
    margin-bottom: var(--gap-2);
  }
}
.fn-preferences__blocks ul + .f-flex + * {
  margin-block-start: 30px;
}
.fn-preferences__blocks li::before {
  background-color: #6d6e71;
}
.fn-preferences__blocks h5 {
  color: var(--clrProfile);
  margin-bottom: calc(var(--hGap) / 2);
}
.fn-preferences__blocks h5 + ul li {
  font-size: 16px;
}
.fn-preferences__blocks p {
  font-size: 16px;
}

.fn-communicate__items {
  padding-block: 30px;
}
.fn-communicate__items:first-child {
  padding-top: 0;
}
@media only screen and (max-width: 767px) {
  .fn-communicate__items-heading {
    display: none;
  }
  .fn-communicate__items-heading + div {
    padding-top: 0;
  }
}
.fn-communicate__items:not(:last-child) {
  border-bottom: 1px solid #eee;
}
.fn-communicate__items .fn-communicate__title {
  text-align: center;
  color: #fff;
  background-color: var(--clrProfile);
  padding-block: 30px;
  padding-inline: 20px;
}
@media only screen and (max-width: 767px) {
  .fn-communicate__items .fn-communicate__title {
    padding-block: 12px;
    padding-inline: 15px;
    width: -moz-fit-content;
    width: fit-content;
  }
}
@media only screen and (max-width: 767px) {
  .fn-communicate p::before {
    content: attr(data-title) " : ";
    font-weight: 600;
    margin-right: 3px;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .fn-collaborate .f-col-3 {
    width: 50%;
  }
}
.fn-collaborate__cell {
  background-color: #fff;
  height: 100%;
  padding: 20px;
}
.fn-collaborate__cell h3 {
  color: var(--clrProfile);
  word-break: break-word;
}
.fn-collaborate__cell .custom-list li {
  font-size: 16px;
}

.fn-manage__graph:not(:last-child) {
  margin-bottom: 30px;
}
.fn-manage__graph img {
  max-width: none;
  width: 100%;
}
@media only screen and (max-width: 991px) {
  .fn-manage .fn-col {
    width: 50%;
  }
}
.fn-manage__cell {
  text-align: center;
  max-width: 200px;
  margin-inline: auto;
}
.fn-manage__cell img {
  max-width: 32px;
  max-height: 61px;
  margin-bottom: 20px;
}
.fn-manage__cell h3 {
  width: min-content;
  margin-inline: auto;
}

.fn-tips {
  counter-reset: tips-count;
}
@media only screen and (max-width: 767px) {
  .fn-tips .fn-col {
    width: 100%;
  }
}
.fn-tips__cell {
  height: 100%;
  position: relative;
  padding-left: 60px;
}
.fn-tips__cell::before {
  counter-increment: tips-count;
  content: counter(tips-count) ".";
  color: #6d6e71;
  font-size: 44px;
  font-family: "Museo-700";
  position: absolute;
  top: -5px;
  left: 0;
}
.fn-tips__bottom {
  width: min(1000px, 100%);
  margin-inline: auto;
}
.fn-tips__bottom p a {
  font-size: 20px;
}
.fn-tips__bottom > *:not(:last-child) {
  margin-bottom: 30px;
}
.fn-tips__bottom .btn {
  padding: 10px 25px;
  font-size: 1.2em;
}

.modal-header {
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
}

.pa_assessment {
  line-height: 2em;
  padding: 0.75rem 0.75rem 0.75rem 0 !important;
}

.clearfix {
  clear: both;
}

.package-form select {
  border: 1px solid #ddd;
  padding: 10px !important;
  height: 40px;
  background: #F8F8F8;
  color: #636363;
  font-family: "Museo-300";
  margin-bottom: 10px;
  width: 55%;
}
.package-form .assessment-select select {
  height: 30px;
  padding: 5px !important;
  width: 45%;
  background-color: #fff;
}
.package-form label {
  width: 55%;
  line-height: 2em;
  padding: 0.75rem 0.75rem 0.75rem 0;
  margin-bottom: 5px;
}
.package-form .btn {
  margin-top: 10px;
}
.package-form .btn-sm {
  padding: 5px 10px;
}
.package-form .guide-rdbtn {
  padding-bottom: 25px;
}
.package-form .guide-rdbtn label {
  padding: 0 !important;
  width: 65%;
}
.package-form .guide-rdbtn--disable {
  pointer-events: none;
  opacity: 0.5;
}
.package-form .modal-body__buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  border-top: 1px solid #ddd;
  width: calc(100% + 32px);
  margin: 0 -16px;
  padding: 5px 10px;
  background-color: #f6f6f6;
}
.package-form .modal-body__buttons .btn {
  margin-top: 0;
}
.package-form .modal-body__buttons .btn-prim {
  margin-inline-start: 10px;
}
.package-form .modal-body__buttons .btn-disable {
  cursor: not-allowed;
  pointer-events: none;
}

.modal-title {
  float: left;
}
.modal-title--fs {
  font-size: 16px;
}

.modal-body {
  padding: 20px 30px 0;
}

.modal-pf .col-sm-5 {
  padding: 0 15px;
}
.modal-pf .right-button p {
  margin-bottom: 10px;
}
.modal-pf .right-button.text-right {
  width: 100%;
  text-align: center;
  margin: 3px 0 8px;
}
.modal-pf .right-button.text-right a {
  padding: 5px 10px;
  width: 100%;
}

.fn__guidbtn {
  position: relative;
  padding-bottom: 20px;
  max-width: 820px;
  width: 100%;
}
.fn__guidbtn a {
  position: absolute;
  right: -10px;
  top: 0;
  width: 100%;
  max-width: 245px;
  cursor: pointer;
  border-radius: 4px;
}
@media only screen and (max-width: 991px) {
  .fn__guidbtn a {
    right: 0;
  }
}

.guide-modal {
  display: none;
}

/****************
    14-December 
****************/
.fn-profile__pic figure {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/custom-profile/interpretive-guide/interpretive-guide.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC9HF;;ADiIA;EACE,aAAA;EACA,eAAA;AC9HF;;ADiIA;EACE,sBAAA;AC9HF;;ADiIA;EACE,8BAAA;AC9HF;;ADiIA;EACE,gBAAA;AC9HF;;ADiIA;EACE,gBAAA;AC9HF;;ADiIA;EACE,aAAA;AC9HF;;ADiIA;EACE,gBAAA;AC9HF;;AD4IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ACzIJ;AD2II;;;;;;EACE,gBAAA;ACpIN;ADwIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC3BX;ADwII;EALF;;IAMI,eA/GY;ECrBhB;AACF;ADuIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACpBX;ADuII;EALF;;IAMI,eArHY;ECdhB;AACF;ADsIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACbX;ADsII;EALF;;IAMI,eA3HY;ECPhB;AACF;ADqIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACNX;ADsIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACJX;ADuIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACFX;AD2IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ACzIJ;AD2II;EACE,gBAAA;ACzIN;AD4II;EAXF;IAYI,eAAA;ECzIJ;AACF;AD4IE;;EAEE,UAAA;EACA,SAAA;AC1IJ;AD6IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC3IJ;;AD+IA;EACE,sBAxNQ;AC4EV;;AD+IA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC5IF;AD8IE;EALF;IAMI,cAAA;EC3IF;AACF;AD6IE;EACE,iBA1Ka;AC+BjB;AD8IE;EACE,gBApLa;EAqLb,WAAA;AC5IJ;;ADiJE;EACE,kBAAA;AC9IJ;ADiJE;EACE,iBAAA;AC/IJ;;ADoJE;EACE,aAAA;ACjJJ;;ADqJA;EACE,kBAAA;AClJF;ADoJE;EACE,mBAAA;AClJJ;ADsJI;EACE,sBAAA;ACpJN;ADwJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACwEnB;ADwJI;EACE,sBAAA;ACtJN;ADyJI;EAVF;IAWI,eApOoB;EC8ExB;AACF;ADyJE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACvJJ;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EACE,WAAA;ACxJN;AD2JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACmMZ;;AD8JA;EACE,mBA1PO;AC+FT;AD6JE;EAHF;IAII,mBAAA;EC1JF;AACF;AD4JE;EACE,mBAAA;AC1JJ;AD6JE;EACE,aArQK;AC0GT;AD6JI;EAHF;IAII,aAAA;EC1JJ;AACF;AD4JI;EACE,aAAA;AC1JN;;AD+JA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC5JF;AD8JE;EACE,eAAA;AC5JJ;AD+JE;EACE,sCAAA;AC7JJ;ADgKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC9JJ;;AD6KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC1KJ;AD4KI;EACE,kBAAA;AC1KN;AD6KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC3KN;;ADgLA;EACE,8BAAA;AC7KF;;ADgLA;EACE,8BAAA;AC7KF;;ADgLA;EACE,+BAAA;AC7KF;;ADgLA;EACE,8BAAA;AC7KF;;ADgLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC7KF;AD+KE;EACE,2BAAA;EACA,mBAAA;AC7KJ;ADgLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC4PX;ADiLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AC/KJ;ADkLE;EACE,yBAjckB;EAkclB,cArciB;ACqRrB;ADmLE;EACE,yBAvbS;EAwbT,WA1bO;ACyQX;ADmLI;EACE,6BAAA;ACjLN;;ADsLA;EACE;IACE,uBAAA;ECnLF;EDsLA;IACE,yBAAA;ECpLF;AACF;ADuLA;EACE,8BAAA;ACrLF;;ADwLA;EACE,8BAAA;ACrLF;;ADwLA;EACE,+BAAA;ACrLF;;ADwLA;EACE,8BAAA;ACrLF;;ADwLA;EACE,qBAAA;ACrLF;;ADwLA;EACE,UAAA;ACrLF;ADuLE;EACE,qBAAA;ACrLJ;;ADyLA;EACE,UAAA;ACtLF;;AD0LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACxLJ;AD2LM;EACE,mBAAA;ACzLR;AD8LE;EACE,2BAAA;AC5LJ;AD+LE;EACE,uBAAA;AC7LJ;ADgME;EACE,mBAAA;AC9LJ;;ADmME;EACE,mBAAA;AChMJ;ADmME;EACE,yBAAA;ACjMJ;ADoME;EACE,sBAAA;AClMJ;ADqME;EACE,uBAAA;ACnMJ;ADsME;EACE,oBAAA;ACpMJ;;AAvYE;EAEE,uBAAA;EACA,mBAAA;AAyYJ;AAvYI;EACE,sBAAA;AAyYN;AArYE;EAEE,eAAA;AAsYJ;AApYI;EACE,mBAAA;AAsYN;AA/XY;EACE,aAAA;AAiYd;AA3XM;EACE,2BAAA;AA6XR;AAtXY;EACE,UAAA;EACA,kCAAA;AAwXd;AAlXM;EACE,iBAAA;AAoXR;AAlXQ;EAHF;IAII,0BAAA;EAqXR;AACF;AAjXQ;EADF;IAEI,UAAA;EAoXR;AACF;AA/WQ;EADF;IAEI,UAAA;EAkXR;AACF;AA7WI;EACE,kBAAA;AA+WN;AA7WM;EACE,UAAA;AA+WR;AA7WQ;EAHF;IAII,WAAA;EAgXR;EA9WQ;IACE,mBAAA;EAgXV;AACF;AA5WM;EACE,UAAA;AA8WR;AA5WQ;EAHF;IAII,WAAA;EA+WR;AACF;AA1WE;EAEE,gBAAA;EACA,WAAA;EACA,mBAAA;AA2WJ;AAxWI;EAPF;IAQI,YAAA;EA2WJ;AACF;AAzWI;EACE,kBAAA;EACA,oBAAA;AA2WN;AAzWM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,mCAAA;EACA,UAAA;EACA,YAAA;EACA,6FAAA;AA2WR;AAzWQ;EAVF;IAWI,aAAA;EA4WR;AACF;AAzWM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,iCAAA;EACA,WAAA;EACA,WAAA;EACA,6FAAA;AA2WR;AAzWQ;EAVF;IAWI,aAAA;EA4WR;AACF;AAzWM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AA2WR;AAvWI;EACE,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAyWN;AApWE;EACE,cAAA;EACA,mBAAA;AAsWJ;AApWI;EACE,gBAAA;AAsWN;;AA/VE;EACE,yBD5IiB;EC6IjB,aAAA;AAkWJ;AAhWI;EAJF;IAKI,aAAA;EAmWJ;AACF;AAjWI;EACE,WDpIK;ACueX;AAjWM;EAHF;IAII,0BAAA;EAoWN;AACF;AAjWI;EACE,WD5IK;EC6IL,mBAAA;EACA,wEDtMO;ECuMP,gBAAA;AAmWN;AAhWI;EACE,WDnJK;ACqfX;AA9VE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;AAgWJ;AA9VI;EALF;IAMI,gBAAA;EAiWJ;AACF;AA/VI;EACE,cDhLmB;ACihBzB;AA9VI;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AAgWN;AA5VM;EADF;IAEI,8BAAA;EA+VN;AACF;;AAvVE;EACE,mBAAA;AA0VJ;AAxVI;EACE,YAAA;AA0VN;AAtVE;EACE,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAwVJ;AArVI;EATF;IAUI,gBAAA;IACA,SAAA;IACA,WAAA;EAwVJ;AACF;AAnVI;EAEE,gBAAA;AAoVN;AAlVM;EAEE;IACE,gBAAA;EAmVR;AACF;AAhVM;EACE,2BAAA;AAkVR;AA/UM;EAEE,kBAAA;EACA,0BAAA;AAgVR;AA9UQ;EALF;IAMI,aAAA;EAiVR;AACF;AA/UQ;EACE,mCAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;AAiVV;AA/UU;EARF;IASI,6BAAA;EAkVV;AACF;AAhVU;EACE,sCAAA;AAkVZ;AAhVY;EAHF;IAII,0BAAA;EAmVZ;AACF;AA7UU;EAFF;IAGI,yBAAA;EAgVV;AACF;AA5UU;EADF;IAEI,WAAA;EA+UV;EA7UU;IACE,mBAAA;EA+UZ;AACF;AAzUI;EACE,WDhRK;AC2lBX;AAxUI;EACE,wED5UO;EC6UP,eD/OK;ECgPL,WDtRK;ECuRL,gBAAA;EACA,mBAAA;AA0UN;AAxUM;EAPF;IAQI,eDpPU;EC+jBhB;AACF;AAtUM;EACE,wBAAA;AAwUR;AApUU;EAFF;IAGI,WAAA;EAuUV;EArUU;IACE,2BAAA;EAuUZ;AACF;AAnUQ;EACE,wBAAA;AAqUV;AA9TM;EACE,yBDxUa;ACwoBrB;AA5TI;EACE,wBAAA;EACA,oCAAA;AA8TN;AA1TQ;EACE,eAAA;AA4TV;AAvTI;EACE,eAAA;AAyTN;;AAjTE;EACE,mBAAA;AAoTJ;AAlTI;EACE,cAAA;AAoTN;AA/SM;EAFF;IAGI,aAAA;EAkTN;EAhTM;IACE,cAAA;EAkTR;AACF;AA9SI;EACE,6BAAA;AAgTN;AA7SI;EACE,kBAAA;EACA,WDzWK;EC0WL,mCAAA;EACA,mBAAA;EACA,oBAAA;AA+SN;AA7SM;EAPF;IAQI,mBAAA;IACA,oBAAA;IACA,uBAAA;IAAA,kBAAA;EAgTN;AACF;AA1SI;EAEE;IACE,+BAAA;IACA,gBAAA;IACA,iBAAA;EA2SN;AACF;;AAjSI;EAFF;IAGI,UAAA;EAqSJ;AACF;AAlSE;EAEE,sBD/YO;ECgZP,YAAA;EACA,aAAA;AAmSJ;AAjSI;EACE,wBAAA;EACA,sBAAA;AAmSN;AA9RM;EACE,eAAA;AAgSR;;AAtRI;EACE,mBAAA;AAyRN;AAtRI;EACE,eAAA;EACA,WAAA;AAwRN;AAlRI;EAFF;IAGI,UAAA;EAqRJ;AACF;AAlRE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAoRJ;AAlRI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAoRN;AAjRI;EACE,kBAAA;EACA,mBAAA;AAmRN;;AA9QA;EACE,yBAAA;AAiRF;AA9QI;EADF;IAEI,WAAA;EAiRJ;AACF;AA9QE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;AAgRJ;AA9QI;EACE,6BAAA;EACA,gCAAA;EACA,cDzee;EC0ef,eDhcK;ECicL,wBD9gBK;EC+gBL,kBAAA;EACA,SAAA;EACA,OAAA;AAgRN;AA5QE;EACE,wBAAA;EACA,mBAAA;AA8QJ;AA3QM;EACE,eAAA;AA6QR;AAzQI;EACE,mBAAA;AA2QN;AAxQI;EACE,kBAAA;EACA,gBAAA;AA0QN;;AArQA;EACE,aAAA;EACA,gCAAA;AAwQF;;AArQA;EACE,gBAAA;EACA,6CAAA;AAwQF;;AArQA;EACE,WAAA;AAwQF;;AAnQE;EACE,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;EACA,UAAA;AAsQJ;AAjQI;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,sBAAA;AAmQN;AA/PE;EACE,UAAA;EACA,gBAAA;EACA,kCAAA;EACA,kBAAA;AAiQJ;AA9PE;EACE,gBAAA;AAgQJ;AA9PI;EACE,iBAAA;AAgQN;AA5PE;EACE,oBAAA;AA8PJ;AA5PI;EACE,qBAAA;EACA,UAAA;AA8PN;AA3PI;EACE,oBAAA;EACA,YAAA;AA6PN;AAzPE;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AA2PJ;AAzPI;EACE,aAAA;AA2PN;AAzPM;EACE,yBAAA;AA2PR;AAvPM;EACE,mBAAA;EACA,oBAAA;AAyPR;;AAnPA;EACE,WAAA;AAsPF;AApPE;EACE,eAAA;AAsPJ;;AAlPA;EACE,oBAAA;AAqPF;;AAjPE;EACE,eAAA;AAoPJ;AA/OI;EACE,mBAAA;AAiPN;AA9OI;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;AAgPN;AA9OM;EACE,iBAAA;EACA,WAAA;AAgPR;;AA1OA;EACE,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;AA6OF;AA3OE;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AA6OJ;AA3OI;EATF;IAUI,QAAA;EA8OJ;AACF;;AA1OA;EACC,aAAA;AA6OD;;AA1OA;;gBAAA;AAYI;EACE,SAAA;AAoON","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","// fonts\n@import '../../../../assets/styles/variables';\n\n@import url('https://assets.foursightonline.com/app/fonts/webfonts/webfonts.css');\n\n$profile: '.fn-profile';\n\n#{$profile} {\n\n  .section-title {\n\n    width: min(620px, 100%);\n    margin-inline: auto;\n\n    &__linkcontainer {\n      flex-direction: column;\n    }\n  }\n\n  &__blocks {\n\n    --dotsGap: 10px;\n\n    .f-flex {\n      align-items: center;\n\n      &:nth-child(1) {\n        .fn-profile__pic {\n\n          figure {\n\n            &::before {\n              display: none;\n            }\n          }\n        }\n      }\n\n      &:nth-child(even) {\n        flex-direction: row-reverse;\n\n\n        #{$profile}__pic {\n\n          figure {\n\n            &::after {\n              left: auto;\n              right: calc(100% + var(--dotsGap));\n            }\n          }\n        }\n      }\n\n      &+div {\n        margin-top: 100px;\n\n        @media #{$mobile} {\n          margin-top: calc(#{$secPad} / 2);\n        }\n      }\n\n      &>div:first-child {\n        @media #{$mobile-up} {\n          width: 45%;\n        }\n\n      }\n\n      &>div:last-child {\n        @media #{$mobile-up} {\n          width: 55%;\n        }\n\n      }\n    }\n\n    .fn-col {\n      position: relative;\n\n      &:nth-child(1) {\n        width: 45%;\n\n        @media #{$mobile} {\n          width: 100%;\n\n          &:not(:last-child) {\n            margin-bottom: 20px;\n          }\n        }\n      }\n\n      &:nth-child(2) {\n        width: 55%;\n\n        @media #{$mobile} {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  &__pic {\n\n    max-width: 284px;\n    width: 100%;\n    margin-inline: auto;\n\n\n    @media #{$mobile} {\n      width: 200px;\n    }\n\n    figure {\n      position: relative;\n      padding-bottom: 100%;\n\n      &::before {\n        content: \"\";\n        position: absolute;\n        left: 50%;\n        transform: translateX(-50%);\n        bottom: calc(100% + var(--dotsGap));\n        width: 8px;\n        height: 60px;\n        background-image: url(#{$adminUpload}226/original.png);\n\n        @media #{$tablet} {\n          display: none;\n        }\n      }\n\n      &::after {\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        left: calc(100% + var(--dotsGap));\n        width: 62px;\n        height: 8px;\n        background-image: url(#{$adminUpload}219/original.png);\n\n        @media #{$tablet} {\n          display: none;\n        }\n      }\n\n      img {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        border-radius: 100%;\n      }\n    }\n\n    h5 {\n      font-size: calc(#{$fn-fs-h6} - 2px);\n      margin-top: 20px;\n      text-align: center;\n      max-width: 170px;\n      margin-inline: auto;\n\n    }\n  }\n\n  &__content {\n    max-width: 88%;\n    margin-inline: auto;\n\n    p {\n      line-height: 1.8;\n    }\n  }\n}\n\n.fn-framework {\n\n  &__top {\n    background-color: $color-neutral-dark;\n    padding: calc($secPad / 2);\n\n    @media #{$tablet} {\n      padding: 30px;\n    }\n\n    h2 {\n      color: $clrWhite;\n\n      @media #{$mobile} {\n        margin-bottom: var(--hGap);\n      }\n    }\n\n    h3 {\n      color: $clrWhite;\n      font-weight: normal;\n      font-family: $font-stack;\n      line-height: 1.4;\n    }\n\n    p {\n      color: $clrWhite;\n    }\n  }\n\n  &__bottom {\n    max-width: 800px;\n    margin-inline: auto;\n    margin-top: calc($secPad / 2);\n\n    @media #{$mobile} {\n      margin-top: calc($secPad / 2);\n    }\n\n    p {\n      color: $color-neutral-dark-500;\n    }\n\n    img {\n      width: 334px;\n      margin-inline: auto;\n      display: block;\n    }\n\n    .fn-row {\n      @media #{$mobile} {\n        flex-direction: column-reverse;\n      }\n    }\n  }\n}\n\n\n.fn-preferences {\n\n  &__sign {\n    margin-bottom: 30px;\n\n    img {\n      width: 130px;\n    }\n  }\n\n  &__icon {\n    position: absolute;\n    top: calc(#{$secPad} - 20px);\n    right: calc(#{$secPad} - 20px);\n    max-width: 220px;\n    max-height: 180px;\n    z-index: -1;\n\n\n    @media #{$mobile} {\n      max-width: 150px;\n      top: 20px;\n      right: 20px;\n    }\n  }\n\n  &__blocks {\n\n    &>.f-flex {\n\n      margin-inline: 0;\n\n      @media #{$mobile} {\n\n        &+div {\n          margin-top: calc($secPad / 2);\n        }\n      }\n\n      &:nth-child(even) {\n        flex-direction: row-reverse;\n      }\n\n      &>[class*=\"f-col-\"] {\n\n        position: relative;\n        padding: calc(#{$secPad} - 20px);\n\n        @media #{$mobile} {\n          padding: calc($secPad / 3);\n        }\n\n        &:nth-child(1) {\n          background-color: var(--clrProfile);\n          display: flex;\n          flex-wrap: wrap;\n          justify-content: center;\n          flex-direction: column;\n          z-index: 0;\n\n          @media #{$mobile} {\n            border-top-right-radius: ($secPad - 10);\n          }\n\n          &>*:not(:last-child) {\n            margin-bottom: calc(var(--hGap) * 2.5);\n\n            @media #{$mobile} {\n              margin-bottom: var(--hGap);\n            }\n          }\n        }\n\n        &:nth-child(2) {\n\n          @media #{$mobile} {\n            background-color: darken($clrWhite , 5%);\n          }\n        }\n\n        [class*=\"f-col-\"] {\n          @media #{$mobile} {\n            width: 100%;\n\n            &:not(:last-child) {\n              margin-bottom: calc($secPad / 2);\n            }\n          }\n        }\n      }\n    }\n\n    h2 {\n      color: $clrWhite;\n    }\n\n    h3 {\n      font-family: $font-stack;\n      font-size: $fn-fs-h4;\n      color: $clrWhite;\n      line-height: 1.3;\n      font-weight: normal;\n\n      @media #{$mobile} {\n        font-size: $fn-fs-h4-mobile;\n      }\n    }\n\n    ul {\n\n      &+.f-flex {\n        margin-block-start: ($secPad - 30px);\n\n        &>[class*=\"f-col-\"] {\n\n          @media #{$tablet} {\n            width: 100%;\n\n            &:not(:last-child) {\n              margin-bottom: var(--gap-2);\n            }\n          }\n        }\n\n        &+* {\n          margin-block-start: ($secPad - 30px);\n        }\n      }\n    }\n\n    li {\n\n      &::before {\n        background-color: $color-neutral-dark;\n      }\n    }\n\n    h5 {\n      color: var(--clrProfile);\n      margin-bottom: calc(var(--hGap) / 2);\n\n      &+ul {\n\n        li {\n          font-size: 16px;\n        }\n      }\n    }\n\n    p {\n      font-size: 16px;\n    }\n  }\n}\n\n\n.fn-communicate {\n\n  &__items {\n    padding-block: calc($secPad / 2);\n\n    &:first-child {\n      padding-top: 0;\n    }\n\n    &-heading {\n\n      @media #{$mobile} {\n        display: none;\n\n        &+div {\n          padding-top: 0;\n        }\n      }\n    }\n\n    &:not(:last-child) {\n      border-bottom: 1px solid $clrGrey;\n    }\n\n    .fn-communicate__title {\n      text-align: center;\n      color: $clrWhite;\n      background-color: var(--clrProfile);\n      padding-block: calc($secPad / 2);\n      padding-inline: calc($secPad / 3);\n\n      @media #{$mobile} {\n        padding-block: calc($secPad / 5);\n        padding-inline: calc($secPad / 4);\n        width: fit-content;\n      }\n    }\n  }\n\n  p {\n\n    @media #{$mobile} {\n\n      &::before {\n        content: attr(data-title) \" : \";\n        font-weight: 600;\n        margin-right: 3px;\n      }\n    }\n  }\n}\n\n\n.fn-collaborate {\n\n  .f-col-3 {\n\n    @media (min-width: 768px) and (max-width: 991px) {\n      width: 50%;\n    }\n  }\n\n  &__cell {\n\n    background-color: $clrWhite;\n    height: 100%;\n    padding: calc($secPad / 3);\n\n    h3 {\n      color: var(--clrProfile);\n      word-break: break-word;\n    }\n\n    .custom-list {\n\n      li {\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n.fn-manage {\n\n  &__graph {\n\n    &:not(:last-child) {\n      margin-bottom: calc($secPad / 2);\n    }\n\n    img {\n      max-width: none;\n      width: 100%;\n    }\n  }\n\n  .fn-col {\n\n    @media #{$tablet} {\n      width: 50%;\n    }\n  }\n\n  &__cell {\n    text-align: center;\n    max-width: 200px;\n    margin-inline: auto;\n\n    img {\n      max-width: 32px;\n      max-height: 61px;\n      margin-bottom: calc($secPad / 3);\n    }\n\n    h3 {\n      width: min-content;\n      margin-inline: auto;\n    }\n  }\n}\n\n.fn-tips {\n  counter-reset: tips-count;\n\n  .fn-col {\n    @media #{$mobile} {\n      width: 100%;\n    }\n  }\n\n  &__cell {\n    height: 100%;\n    position: relative;\n    padding-left: ($secPad);\n\n    &::before {\n      counter-increment: tips-count;\n      content: counter(tips-count) \".\";\n      color: $color-neutral-dark;\n      font-size: $fn-fs-h1;\n      font-family: $muso-700;\n      position: absolute;\n      top: -5px;\n      left: 0;\n    }\n  }\n\n  &__bottom {\n    width: min(1000px, 100%);\n    margin-inline: auto;\n\n    p {\n      a {\n        font-size: 20px;\n      }\n    }\n\n    &>*:not(:last-child) {\n      margin-bottom: calc($secPad / 2);\n    }\n\n    .btn {\n      padding: 10px 25px;\n      font-size: 1.2em;\n    }\n  }\n}\n\n.modal-header {\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.pa_assessment {\n  line-height: 2em;\n  padding: 0.75rem 0.75rem 0.75rem 0 !important;\n}\n\n.clearfix {\n  clear: both;\n}\n\n.package-form {\n\n  select {\n    border: 1px solid #ddd;\n    padding: 10px !important;\n    height: 40px;\n    background: #F8F8F8;\n    color: #636363;\n    font-family: \"Museo-300\";\n    margin-bottom: 10px;\n    width: 55%;\n  }\n\n  .assessment-select {\n\n    select {\n      height: 30px;\n      padding: 5px !important;\n      width: 45%;\n      background-color: #fff;\n    }\n  }\n\n  label {\n    width: 55%;\n    line-height: 2em;\n    padding: 0.75rem 0.75rem 0.75rem 0;\n    margin-bottom: 5px;\n  }\n\n  .btn {\n    margin-top: 10px;\n\n    &-sm {\n      padding: 5px 10px;\n    }\n  }\n\n  .guide-rdbtn {\n    padding-bottom: 25px;\n\n    label {\n      padding: 0 !important;\n      width: 65%;\n    }\n\n    &--disable {\n      pointer-events: none;\n      opacity: 0.5;\n    }\n  }\n\n  .modal-body__buttons {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    border-top: 1px solid #ddd;\n    width: calc(100% + 32px);\n    margin: 0 -16px;\n    padding: 5px 10px;\n    background-color: #f6f6f6;\n\n    .btn {\n      margin-top: 0;\n\n      &-prim {\n        margin-inline-start: 10px;\n\n      }\n\n      &-disable {\n        cursor: not-allowed;\n        pointer-events: none;\n      }\n    }\n  }\n}\n\n.modal-title {\n  float: left;\n\n  &--fs {\n    font-size: 16px;\n  }\n}\n\n.modal-body {\n  padding: 20px 30px 0;\n}\n\n.modal-pf {\n  .col-sm-5 {\n    padding: 0 15px;\n  }\n\n  .right-button {\n\n    p {\n      margin-bottom: 10px;\n    }\n\n    &.text-right {\n      width: 100%;\n      text-align: center;\n      margin: 3px 0 8px;\n\n      a {\n        padding: 5px 10px;\n        width: 100%;\n      }\n    }\n  }\n}\n\n.fn__guidbtn {\n  position: relative;\n  padding-bottom: 20px;\n  max-width: 820px;\n  width: 100%;\n\n  a {\n    position: absolute;\n    right: -10px;\n    top: 0;\n    width: 100%;\n    max-width: 245px;\n    cursor: pointer;\n    border-radius: 4px;\n    \n    @media #{$tablet} {\n      right: 0;\n    }\n  }\n}\n\n.guide-modal {\n\tdisplay: none;\n}\n\n/****************\n    14-December \n****************/\n\n// Profile Styling\n\n$profile: '.fn-profile';\n\n#{$profile} {\n\n  &__pic {\n\n    figure {\n      margin: 0;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
